import React, { useRef, useEffect } from 'react';
import { MAX_FRET } from '../../../utils/guitarTuning';

const ALL_FRETS = Array.from({ length: MAX_FRET + 1 }, (_, i) => i);

interface FretScrollerProps {
  value: number | null;
  onChange: (fret: number | null) => void;
}

const FretScroller: React.FC<FretScrollerProps> = ({ value, onChange }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current && value !== null) {
      const btn = scrollRef.current.querySelector(`[data-fret="${value}"]`);
      if (btn) btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }, [value]);

  return (
    <div
      ref={scrollRef}
      className="flex gap-1.5 overflow-x-auto pb-1 scrollbar-hide"
      style={{ WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none' } as React.CSSProperties}
    >
      {ALL_FRETS.map((f) => {
        const isActive = value === f;
        return (
          <button
            key={f}
            data-fret={f}
            onClick={() => onChange(isActive ? null : f)}
            className={`min-w-[44px] md:min-w-[52px] h-11 md:h-12 rounded-xl flex-shrink-0 text-[15px] md:text-base transition-all
              ${isActive
                ? 'border-2 border-amber-500 bg-amber-900/30 text-amber-400 font-bold'
                : 'border border-slate-700 bg-slate-800 text-slate-400 font-medium cursor-pointer hover:border-slate-600'
              }`}
          >
            {f}
          </button>
        );
      })}
    </div>
  );
};

export default FretScroller;
